import React from 'react'
import cx from 'classnames'
import { Message } from 'sb-react-intl'

import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'

import s from './CrossedPrice.scss'
import messages from './messages'


type CrossedPriceProps = {
  className?: string
  price: string
}


const CrossedPrice: React.FunctionComponent<CrossedPriceProps> = ({ className, price }) => (
  <del className={cx(s.crossedPrice, className)}>
    <VisuallyHidden>
      <Message text={messages.text} />
    </VisuallyHidden>
    {price}
  </del>
)


export default CrossedPrice
